import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CurrencyProvider } from "./context/CurrencyContext";
import { TenantProvider } from "./context/TenantContext";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <TenantProvider>
          <CurrencyProvider>
            <AppRoutes />
          </CurrencyProvider>
        </TenantProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
